<template>

  <div>
    <div>
      <Header></Header>
      <!--  意见反馈-->


      <Footer></Footer>
    </div>

  </div>

</template>


<script>

import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";

export default {

  name: "Feedback",

  props: [],

  components: {Header, Footer},

  data() {

    return {}

  },

  methods: {},

  mounted() {


  }

}

</script>


<style type="text/scss" lang="scss" scoped>


</style>
